/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Scan_RequiredInputs */

const en_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both files and click "Scan tracks" to detect their track layout.`)
};

const fr_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les deux fichiers et cliquez sur « Analyser les pistes » pour détecter leur disposition.`)
};

const de_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie beide Dateien aus und klicken Sie auf „Spuren scannen“, um deren Spurlayout zu erkennen.`)
};

const it_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona entrambi i file e fai clic su "Scansiona tracce" per rilevare la loro struttura.`)
};

const ru_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите оба файла и нажмите «Сканировать дорожки», чтобы определить их расположение.`)
};

const es_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione ambos archivos y haga clic en "Escanear pistas" para detectar su trazado.`)
};

const zh_cn2_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择这两个文件，然后点击“扫描音轨”来检测它们的音轨布局。`)
};

const ja_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両方のファイルを選択し、「トラックをスキャン」をクリックしてトラックレイアウトを検出します。`)
};

const hi_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोनों फाइलों का चयन करें और उनके ट्रैक लेआउट का पता लगाने के लिए "स्कैन ट्रैक्स" पर क्लिक करें।`)
};

const pt_pt2_audio_embed_export_scan_required = /** @type {(inputs: Audio_Embed_Export_Scan_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione ambos os arquivos e clique em "Escanear faixas" para detectar o layout das faixas.`)
};

/**
* | output |
* | --- |
* | "Select both files and click \"Scan tracks\" to detect their track layout." |
*
* @param {Audio_Embed_Export_Scan_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan_required = /** @type {((inputs?: Audio_Embed_Export_Scan_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Scan_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_scan_required(inputs)
	if (locale === "de") return de_audio_embed_export_scan_required(inputs)
	if (locale === "it") return it_audio_embed_export_scan_required(inputs)
	if (locale === "ru") return ru_audio_embed_export_scan_required(inputs)
	if (locale === "es") return es_audio_embed_export_scan_required(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_scan_required(inputs)
	if (locale === "ja") return ja_audio_embed_export_scan_required(inputs)
	if (locale === "hi") return hi_audio_embed_export_scan_required(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_scan_required(inputs)
	return en_audio_embed_export_scan_required(inputs)
});